import React from 'react'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { Profile } from './Profile'

export const ProfileWithRollout = () => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.PROFILE}
    >
      <Profile />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

export default ProfileWithRollout
